export const ONE_KILOBYTE = 1024 as const;

export const ONE_MEGABYTE = (ONE_KILOBYTE * 1024) as 1048576;
